const PAGE_HEADER = {
  TITLE: 'Automation Rules',
  HELPTEXT:
    'Automation rules will automate certain tasks according to the criteria and actions you set in the rule. The rules will apply when your customers submit their return request.'
};

const NO_UPDATE_MSG = 'To edit this rule please contact our support team.';

export { PAGE_HEADER, NO_UPDATE_MSG };
